<template>
  <div
    :class="topType === 'black' ? 'top-header-black' : 'top-header'"
  >
    <a
      class="back"
      uigs="head_back"
      href="javascript:history.go(-1)"
    />
    <h1>{{ title }}</h1>
    <a
      :href="'/?source=node&spver=' + spver"
      class="home"
      uigs="head_home"
    />
    <a
      :href="'/hotsugg?spver=' + spver"
      class="search"
      uigs="head_search"
    />
  </div>
</template>

<script>
import { getSpver } from '../../common/js/util';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    topType: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
  },
  methods: {
    backPrev() {
      window.history.go(-1);
      return false;
    },
  },
};
</script>

<style lang="scss">
@import '../css/_lib.scss';
.top-header {
  height: 57px;
  line-height: 57px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  position: relative;
  padding: 0 14px;
  h1 {
    font-size: 15px;
    color: rgba(255, 255, 255, 1);
  }
  .back {
    @include sprite-item($back);
    @extend %-vertical-center;
    left: 14px;
    z-index: 9999;
  }
  .collect {
    @include sprite-item($collect);
    @extend %-vertical-center;
    right: 0;
  }
  .home {
    @include sprite-item($home);
    @extend %-vertical-center;
    right: 67px;
  }
  .search {
    @include sprite-item($search);
    @extend %-vertical-center;
    right: 22px;
  }
}
.top-header-black {
  height: 57px;
  line-height: 57px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  position: relative;
  padding: 0 14px;
  h1 {
    font-size: 15px;
    color: rgba(85, 85, 85, 1);
  }
  .back {
    @include sprite-item($back_b);
    @extend %-vertical-center;
    left: 14px;
    z-index: 9999;
  }
  .collect {
    @include sprite-item($collect_b);
    @extend %-vertical-center;
    right: 0;
  }
  .home {
    @include sprite-item($home_b);
    @extend %-vertical-center;
    right: 51px;
  }
  .search {
    @include sprite-item($search_b);
    @extend %-vertical-center;
    right: 14px;
  }
}
</style>
